import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms'

/**
 * The blue on/off track used for persona communication settings.
 * The label is the accessible name. Text beside the track is optional.
 */
@Component({
  selector: 'ngx-channel-switch',
  templateUrl: './channel-switch.component.html',
  standalone: true,
  imports: [ReactiveFormsModule]
})
export class ChannelSwitchComponent {
  /** Flag saved on the persona form. */
  @Input({ required: true }) control: UntypedFormControl

  /** Accessible name announced for the switch. */
  @Input({ required: true }) label: string

  /** Caption shown beside the track. */
  @Input() text = ''

  /** Fires after the flag changes, so the parent can clear related fields. */
  @Output() changed = new EventEmitter<Event>()
}
